import React, { Component } from 'react';
import { Table, Row, Col, Alert, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import './index.scss';
import { data1_3_default } from './data';
import Auth from "../../Auth";
import imgSave from "../../saveImg";
import IsLableAuth from "../../IsLableAuth";
import { fillData, saveAllData } from './compute'

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

class index extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM'),
        data: [],
        loading: true,
        loadingSave: false,
        print: false
    }

    componentDidMount() {
        this.getTable1_3(this.state.date);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.print != this.state.print) {
            this.setState({ print: nextProps.print });
        }

    }

    // 获取表格1_3的内容
    getTable1_3 = async (date) => {
        try {
            let dataDefault = JSON.stringify(data1_3_default);
            let data = JSON.parse(dataDefault);
            let d = await fetch(`/kpiInfo?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' });
            let data1 = await d.json();
            let d2 = await fetch(`/_1_3_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' });
            let x = await d2.json();
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            if (data1.data && data1.data.length > 0) {
                data = fillData(data, data1.data);
            }

            this.setState({ data, loading: false });
        } catch (error) {
            console.error(error);
            this.setState({ loading: false });
        }
    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.setState({ data });
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        // console.log(data);return;
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_1_3', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getTable1_3(this.state.date);
                }
                return
            }

            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table1_3', 1.5, '1.20', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { data, date, loading } = this.state;

        const width = (document.body.offsetWidth / 5) >= 400 ? (document.body.offsetWidth / 5) : 400;
        const columns = [{
            title: <div>KPI Standard Range<br />关键绩效指数标准范围</div>,
            dataIndex: 'name',
            key: 'name',
            fixed: "left",
            width: 480,
            render: (text, record, index) => {
                if (index == data.length - 1) {
                    return {
                        children: null,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <div dangerouslySetInnerHTML={{ __html: text }} style={{ padding: 10, textAlign: "left" }} />
                )
            }
        }, {
            title: <div>MTD<br />月累计</div>,
            width: 600,
            children: [{
                title: <div>MTD This Year: Please Critique Actual vs. Forecast (Forecast Accuracy Evaluation)<br />本年当月: 请解释实际和预测差异数超出标准范围的原因 (预测精准性衡量）</div>,
                align: "center",
                width: 600,
                children: [{
                    title: '百分比',
                    width: 100,
                    dataIndex: 'mtd_percent',
                    key: '',
                    align: "center",
                    render: (text, record, index) => {
                        if (index == data.length - 1) {
                            return {
                                children: null,
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        let html = null;
                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        return (
                            <div>
                                {html}
                            </div>
                        )
                    }
                }, {
                    title: '备注',
                    width: 500,
                    dataIndex: 'mtd_note',
                    key: '',
                    align: "center",
                    render: (text, record, index) => {
                        if (index == data.length - 1) {
                            return {
                                children: null,
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        return (
                            <div className="table-color table-color-number">
                                <TextArea
                                    className="input-width"
                                    autosize={{ minRows: 2, maxRows: 8 }}

                                    defaultValue={text}
                                    onBlur={(e) => {
                                        let value = e.target.value;
                                        this.onChange('mtd_note', value, index)
                                    }}
                                />
                            </div>
                        )
                    }
                }]
            }]
        }, {
            title: <div>YTD<br />年累计</div>,
            width,
            children: [{
                title: <div>YTD: Please Critique Actual vs. Last Year<br /> 年累计: 请解释实际和去年差异数超出标准范围的原因</div>,
                align: "center",
                children: [{
                    title: '百分比',
                    width: 100,
                    dataIndex: 'ytd_percent',
                    key: '',
                    align: "center",
                    render: (text, record, index) => {
                        if (index == data.length - 1) {
                            return {
                                children: null,
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        let html = null;
                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        return (
                            <div>
                                {html}
                            </div>
                        )
                    }
                }, {
                    title: '备注',
                    dataIndex: 'ytd_note',
                    key: 'ytd_note',
                    width: 500,
                    align: "center",
                    render: (text, record, index) => {
                        if (index == data.length - 1) {
                            return {
                                children: null,
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        return (
                            <div className="table-color table-color-number">
                                <TextArea
                                    className="input-width"
                                    autosize={{ minRows: 2, maxRows: 8 }}
                                    defaultValue={text}
                                    onBlur={(e) => {
                                        let value = e.target.value;
                                        this.onChange('ytd_note', value, index)
                                    }}
                                />
                            </div>
                        )
                    }

                }]
            }]
        }, {
            title: <div>3-Month-Rolling Forecast<br />后三个月滚动预测</div>,
            width,
            children: [{
                title: <div>3-Month-Rolling Forecast : Please Critique Forecast vs. Last Year<br />后三个月滚动预测: 请解释预测和去年实际差异数超出标准范围的原因</div>,
                align: "center",
                children: [{
                    title: '百分比',
                    width: 100,
                    dataIndex: 'threemonth_percent',
                    key: 'threemonth_percent',
                    align: "center",
                    render: (text, record, index) => {
                        if (index == data.length - 1) {
                            return {
                                children: null,
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        let html = null;
                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        return (
                            <div>
                                {html}
                            </div>
                        )
                    }
                }, {
                    title: '备注',
                    dataIndex: 'threemonth_note',
                    key: 'threemonth_note',
                    width: 500,
                    align: "center",
                    render: (text, record, index) => {
                        if (index == data.length - 1) {
                            return {
                                children: null,
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        return (
                            <div className="table-color table-color-number">
                                <TextArea
                                    className="input-width"
                                    autosize={{ minRows: 2, maxRows: 8 }}

                                    defaultValue={text}
                                    onBlur={(e) => {
                                        let value = e.target.value;
                                        this.onChange('threemonth_note', value, index)
                                    }}
                                />
                            </div>
                        )
                    }
                }]
            }]
        }, {
            title: <div>Whole Year Forecast Total<br />整年预测</div>,
            width,
            children: [{
                title: <div>Whole Year Forecast vs. Budget <br />整年预测对比预算</div>,
                align: "center",
                children: [{
                    title: '百分比',
                    width: 100,
                    dataIndex: 'wholeyear_budget_percent',
                    key: '',
                    align: "center",
                    render: (text, record, index) => {
                        if (index == data.length - 1) {
                            return {
                                children: null,
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        let html = null;
                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        return (
                            <div>
                                {html}
                            </div>
                        )
                    }
                }, {
                    title: '备注',
                    dataIndex: 'wholeyear_budget_note',
                    key: 'wholeyear_budget_note',
                    width: 500,
                    align: "center",
                    render: (text, record, index) => {
                        if (index == data.length - 1) {
                            return {
                                children: null,
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        return (
                            <div className="table-color table-color-number">
                                <TextArea
                                    className="input-width"
                                    autosize={{ minRows: 2, maxRows: 8 }}

                                    defaultValue={text}
                                    onBlur={(e) => {
                                        let value = e.target.value;
                                        this.onChange('wholeyear_budget_note', value, index)
                                    }}
                                />
                            </div>
                        )
                    }
                }]
            }, {
                title: <div>Whole Year Forecast vs. Last Year <br />整年预测对比去年</div>,
                align: "center",
                children: [{
                    title: '百分比',
                    width: 100,
                    dataIndex: 'wholeyear_lastyear_percent',
                    key: 'wholeyear_lastyear_percent',
                    align: "center",
                    render: (text, record, index) => {
                        if (index == data.length - 1) {
                            return {
                                children: null,
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        let html = null;
                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        return (
                            <div>
                                {html}
                            </div>
                        )
                    }
                }, {
                    title: '备注',
                    dataIndex: 'wholeyear_lastyear_note',
                    key: 'wholeyear_lastyear_note',
                    align: "center",
                    width: 500,
                    render: (text, record, index) => {
                        if (index == data.length - 1) {
                            return {
                                children: null,
                                props: {
                                    colSpan: 0
                                }
                            }
                        }
                        return (
                            <div className="table-color table-color-number">
                                <TextArea
                                    className="input-width"
                                    autosize={{ minRows: 2, maxRows: 8 }}

                                    defaultValue={text}
                                    onBlur={(e) => {
                                        let value = e.target.value;
                                        this.onChange('wholeyear_lastyear_note', value, index)
                                    }}
                                />
                            </div>
                        )
                    }
                }]
            }]
        }];



        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 FlowThruAnaltsis table1_3" style={{ marginTop: 50, }}>
                    <Row className="title" id="table1_3" style={{ width: this.state.print ? 3520 : 'auto' }}>
                        <Row>1.2 KPI Standard Range and Critique 关键绩效指数标准范围及超出标准范围的解释</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getTable1_3(str)
                                }}
                            />
                            <Auth isAdmin={true}>
                                <Button
                                    type="primary"
                                    loading={loading}
                                    style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.setState({ loading: true }, async () => {
                                            await saveAllData(date);
                                            this.setState({ loading: false });
                                        })
                                    }}
                                >
                                    保存所有酒店数据
                                </Button>
                            </Auth>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            style={{ width: this.state.print ? 3470 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 3470, y: 550 }}
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => record.id || record.name}
                        />

                    </Row>
                    <Row className="table-footer-btn" style={{ marginBottom: 20 }}>
                        <Alert
                            message={
                                <div>
                                    表格关联
                                    <IsLableAuth auth="read_1" {...this.props} path="#table1_1">1.1</IsLableAuth>
                                </div>
                            }
                            type="info"
                            showIcon
                            style={{ display: "inline-block", marginRight: 10 }}
                        />
                        <Auth loading={this.state.loading} auth="edit_1">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/1-KPI/1-3/index.js